import * as React from "react";
import { match as Match } from "react-router";
import { Client } from "../../../../domain/model/client";
import ClientClientsCreateComponent from "./client_clients_create";
import ClientClientsInfoClientsComponent from "./client_clients_info_clients";

interface IProps {
  match: Match<{ action: string }>;
  isLoading: boolean;
  myClient?: Client;
  clients: Client[];
  anchorEl: any;
  handleCreateSubmit: (values: any) => void;
  handleClick: (event: any) => void;
  handleClose: () => void;
  clientsModalParams: { isVisible: boolean; clientId: string };
  handleUpdateRoleSubmit: (values: any) => void;
  handleClickDelete: (event: React.MouseEvent<HTMLButtonElement>) => void;
  handleClickModalOpen: (event: React.MouseEvent<HTMLButtonElement>) => void;
  handleClickModalClose: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const ClientClientsComponent: React.FC<IProps> = (props) => {
  const {
    isLoading,
    myClient,
    clients,
    handleCreateSubmit,
    match,
    handleUpdateRoleSubmit,
    handleClickDelete,
    clientsModalParams,
    handleClickModalOpen,
    handleClickModalClose,
  } = props;
  const action: string | null = match.params ? match.params.action : null;

  let res: JSX.Element;
  switch (action) {
    case "_create": {
      res = (
        <ClientClientsCreateComponent
          isLoading={isLoading}
          handleCreateSubmit={handleCreateSubmit}
        />
      );
      break;
    }

    default: {
      res = (
        <ClientClientsInfoClientsComponent
          isLoading={isLoading}
          myClient={myClient}
          clients={clients}
          handleUpdateRoleSubmit={handleUpdateRoleSubmit}
          handleClickDelete={handleClickDelete}
          clientsModalParams={clientsModalParams}
          handleClickModalOpen={handleClickModalOpen}
          handleClickModalClose={handleClickModalClose}
        />
      );
    }
  }

  return res;
};

export default ClientClientsComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/clients/client_clients.tsx